<template>
  <CToggleButton :activeTheme :inactiveTheme class="c-check-button" :class="{naked: 'c-check-button-naked'}">
    <CFlex align="center" justify="center" class="c-check-button-icon" :style>
      <CIcon name="check" :size="size ? size - 1 : 12"/>
    </CFlex>
    <slot/>
  </CToggleButton>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CFlex from './CFlex.vue';
  import CIcon from './CIcon.vue';
  import CToggleButton from './buttons/CToggleButton.vue';
  import { Theme } from '@/shared/components/buttons/CButton.vue';

  const props = withDefaults(defineProps<{
    activeTheme?: Theme;
    inactiveTheme?: Theme;
    size?: number;
  }>(), {
    activeTheme: 'light-primary',
    inactiveTheme: 'normal-secondary',
  });

  const style = computed(() => {
    if (!props.size) return {};
    const rems = (props.size ?? 16) / 16;
    return {
      width: rems + 'rem',
      height: rems + 'rem',
    };
  });
</script>

<style lang="scss">
  .c-check-button {
    &-icon {
      width: 1rem;
      height: 1rem;
      border: 2px solid $primary;
      border-radius: $border-radius;
      color: $neutral-0;
      background-color: white;

      .c-icon {
        visibility: hidden;
      }
    }

    &.c-toggle-button-active {
      .c-check-button-icon {
        background-color: $primary;

        .c-icon {
          visibility: visible;
        }
      }
    }

    &.c-button-disabled {
      .c-check-button-icon {
        border-color: $neutral-500;
        color: $neutral-500;
        background-color: $neutral-100;
      }
    }
  }
</style>